module.exports = __webpack_public_path__ + "static/media/event-services-img8.9257dd94.jpg";